// Generate DSL syntax from canvas state

export const generateDSL = (tables, relationships) => {
  let dsl = '';
  
  // Create a map of column IDs to column names for relationship lookup
  const columnMap = {};
  tables.forEach(table => {
    table.columns.forEach(col => {
      columnMap[col.id] = { tableName: table.name, columnName: col.name };
    });
  });
  
  // Create a map of relationships by source column ID
  const relationshipsByColumn = {};
  relationships.forEach(rel => {
    if (rel.source_column_id) {
      relationshipsByColumn[rel.source_column_id] = rel;
    }
  });
  
  tables.forEach((table, index) => {
    if (index > 0) dsl += '\n';
    
    dsl += `${table.name} {\n`;
    
    table.columns.forEach(column => {
      dsl += '  ';
      
      // Column name
      dsl += column.name;
      dsl += ' ';
      
      // Data type with length
      dsl += column.data_type.toLowerCase();
      if (column.length) {
        const dataType = column.data_type.toLowerCase();
        
        // Types that support length/precision
        if (['varchar', 'char', 'int', 'bigint', 'tinyint', 'smallint', 'mediumint'].includes(dataType)) {
          dsl += `(${column.length})`;
        } else if (dataType === 'decimal') {
          dsl += `(${column.length},2)`;
        }
      }
      
      // Constraints
      if (column.is_primary_key) dsl += ' pk';
      if (column.is_auto_increment) dsl += ' increments';
      if (!column.is_nullable) dsl += ' unique';
      if (column.default_value) {
        dsl += ` def(${column.default_value})`;
      }
      
      // Relationship
      const rel = relationshipsByColumn[column.id];
      if (rel && rel.target_column_id) {
        const targetInfo = columnMap[rel.target_column_id];
        if (targetInfo) {
          dsl += ` > ${targetInfo.tableName}.${targetInfo.columnName}`;
        }
      }
      
      dsl += '\n';
    });
    
    dsl += '}\n';
  });
  
  return dsl;
};
